import { assetPath } from '@app/lib/build'
import { request, authenticatedRequest } from '@app/rest/rest.lib'

import type { ClientConfig, IApiConfig, IClinicConfig } from './interfaces'

/**
 * Fetches client config, including api location, from the client environment.
 *
 * Note that this function requests solely from the root-served URL which can
 * be modified with the base href in the entry index html file.  This request
 * is always relative and is used solely for preparing the web client to make
 * configuration requests to the API at initialization.
 */
export function fetchClientConfig() {
  return request<ClientConfig>({
    method: 'get',
    url: assetPath('/configuration.json'),
  })
}

/**
 * Fetches the client connection configuration from api.
 *
 * @param apiLocation The API location as a URL at which to fetch the client
 *        configuration.  The endpoint URL will be appended to this for the
 *        request.
 */
export function fetchApiConfig() {
  return request<IApiConfig>({
    method: 'get',
    url: `/api/v2/client-config`,
  })
}

/**
 * Fetches the clinic configuration from api
 */

export function fetchClinicConfig() {
  return authenticatedRequest<IClinicConfig>({
    method: 'get',
    url: `/api/v2/clinic/config`,
  })
}
